import AwardsSection from "@components/new-ui/AwardsSection";
import CaseStudyFeatureSection, { Feature } from "@components/new-ui/CaseStudyFeatureSection";
import ClientLogos, { LogoObject } from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import Herosection, { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import ProductSection, { Product } from "@components/new-ui/IndustriesSection/ProductSection";
import StatsInfo, { StatsInfoProps } from "@components/new-ui/IndustriesSection/StatsInfo";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import { processEnv } from "@lib/processEnv";
import { IIndustries } from "@pages/industry/finance/whatsapp";
import { windowOpenNewTab } from "@utils/common";
import axios from "axios";
import { GetStaticProps } from "next";
import Image from "next/image";
import React from "react";
import { MdOutlineArrowForwardIos } from "react-icons/md";

const featureInfo1: FeatureInfo = {
    mainTitle: "Optimize appointment management",
    subtitle: "Made possible with automated messages/reminders",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/healthcare/appointment-management.png",
    featureInfoList: [
        "Automated appointment booking confirmations",
        "Timely reminders for upcoming visits",
        "Real-time rescheduling and cancellations",
        "Notifications for follow-ups and check-ups",
    ],
};

const featureInfo2: FeatureInfo = {
    mainTitle: "Enhance patient engagement",
    subtitle: "In just a few clicks – reducing patient worries",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/healthcare/custom-settings.png",
    featureInfoList: [
        "Quick responses to patient inquiries",
        "Sharing specialist availability and schedules",
        "24/7 chatbot assistance for emergencies",
        "Multi-language support for diverse patients",
    ],
};

const featureInfo3: FeatureInfo = {
    mainTitle: "Streamline patient onboarding",
    subtitle: "By making their care-receiving experience seamless",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/healthcare/medical-history.png",
    featureInfoList: [
        "Instant sharing of registration forms",
        "Automated document collection and verification",
        "Welcome messages with onboarding guidance",
        "Manage prescription refill requests",
    ],
};

const featureInfo4: FeatureInfo = {
    mainTitle: "Enable smooth billing assistance",
    subtitle: "Using secure and hassle-free payment processes",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/healthcare/razorpay-integration.png",
    featureInfoList: [
        "Automated payment reminders for invoices",
        "Instant links for secure bill payments",
        "Notifications for insurance claim updates",
        "Sharing detailed billing and payment receipts",
    ],
};

const featureInfo5: FeatureInfo = {
    mainTitle: "Coordinate aftercare services",
    subtitle: "Improve services through actionable insights",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/healthcare/whatsapp-template-creation.png",
    featureInfoList: [
        "Share post-visit care instructions",
        "Monitor recovery progress remotely",
        "Schedule follow-up appointments efficiently",
        "Automated post-visit feedback surveys",
    ],
};

const ecommerceProductCardData: Array<Product> = [
    {
        title: "Click-to-WhatsApp ads",
        description: "Turn awareness from Meta ads to personalized interactions on WhatsApp.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/click-whatsapp-ads.png",
        externalLink: "https://gallabox.com/click-to-whatsapp-ads",
    },
    {
        title: "Broadcast",
        description: "Share health updates, details of wellness programs, diagnostic test package offers.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/broadcast.png",
        externalLink: "https://gallabox.com/whatsapp-broadcast",
    },
    {
        title: "Drip marketing",
        description: "Send timely reminders and nudges to patients to help them keep their appointments.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/drip-marketing.png",
        externalLink: "https://gallabox.com/whatsapp-drip-marketing",
    },
    {
        title: "Flows",
        description: "Collect patient info for a comprehensive medical history profile and assessing urgency.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/whatsapp-flow.png",
        externalLink: "https://gallabox.com/whatsapp-flows",
    },
    {
        title: "Chatbot",
        description: "Answer FAQs, help book and reschedule appointments with human handover options.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/bot.png",
        externalLink: "https://gallabox.com/whatsapp-chatbot",
    },
    {
        title: "Shared team inbox",
        description: "Reduce response time rates and improve patient satisfaction with a single, AI-powered inbox.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/inbox.png",
        externalLink: "https://gallabox.com/whatsapp-shared-inbox",
    },
    {
        title: "AI rewrite",
        description: "Edit your responses with our built-in Gen AI and cater to patients in multiple languages.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/gallabox-gen-ai.png",
        externalLink: "https://gallabox.com/whatsapp-ai-chatbot",
    },
    {
        title: "Payments",
        description: "Request payments in addition to sharing detailed billing info and payment receipts on WhatsApp.",
        imageUrl: "https://assets.gallabox.com/gb-home/industry-logos/education/group.png",
        externalLink: "https://gallabox.com/whatsapp-payments",
    },
];

const caseStudyFeatureCardData: Array<Feature> = [
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/industries/healthcare/itees.png",
        chiptitle: "E-COMMERCE",
        title: "Improving Patient Experience at ITEES Eye Hospital: A Gallabox Success Story",
        statsInfoData: [
            { percentage: "70%", label: "Growth employee productivity" },
            { percentage: "50%", label: "Growth in Patient Footfall" },
            { percentage: "54%", label: "Improved Return Visits" },
        ],
        url: "https://gallabox.com/case-study/itees",
    },
];

const herosectionData: HerosectionProps = {
    chipTitle: "HEALTHCARE",
    title: "Simplify patient care and drive appointment bookings by 100% with WhatsApp automation",
    description:
        "From patient queries to emergency care, Gallabox’s no-code AI chatbots, shared team inbox and payments can streamline your healthcare operations using WhatsApp automation.",
    primaryButtonText: "Try for Free",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/healthcare/healthcare-hero-image.png",
};

const statsInfoData: Array<StatsInfoProps> = [
    { percentage: "54%", label: "Growth in positive patient feedback" },
    { percentage: "61%", label: "Reduction in repetitive, manual tasks" },
    { percentage: "42%", label: "Increase in resource cost optimization" },
];

const clientLogosData: LogoObject[] = [
    { url: "https://assets.gallabox.com/gb-home/industries/healthcare/apollo.svg", alt: "apollo", width: 110, height: 60 },
    { url: "https://assets.gallabox.com/gb-home/industries/healthcare/aravind.svg", alt: "aravind", width: 110, height: 48 },
    { url: "https://assets.gallabox.com/gb-home/industries/healthcare/cutis.svg", alt: "cutis", width: 110, height: 48 },
    { url: "https://assets.gallabox.com/gb-home/industries/healthcare/estetica.svg", alt: "estetica", width: 110, height: 48 },
    { url: "https://assets.gallabox.com/gb-home/industries/healthcare/hi-tech.svg", alt: "hi-tech", width: 110, height: 40 },
    { url: "https://assets.gallabox.com/gb-home/industries/healthcare/hive.svg", alt: "hive", width: 110, height: 90 },
    { url: "https://assets.gallabox.com/gb-home/industries/healthcare/homecared.svg", alt: "homecared", width: 110, height: 38 },
    { url: "https://assets.gallabox.com/gb-home/industries/healthcare/illusion.svg", alt: "illusion", width: 110, height: 60 },
    { url: "https://assets.gallabox.com/gb-home/industries/healthcare/kauvery.svg", alt: "kauvery", width: 110, height: 90 },
    { url: "https://assets.gallabox.com/gb-home/industries/healthcare/med.svg", alt: "med", width: 110, height: 31 },
    { url: "https://assets.gallabox.com/gb-home/industries/healthcare/nura.svg", alt: "nura", width: 110, height: 76 },
    { url: "https://assets.gallabox.com/gb-home/industries/healthcare/tata.svg", alt: "tata", width: 110, height: 51 },
    { url: "https://assets.gallabox.com/gb-home/industries/healthcare/teeth.svg", alt: "teeth", width: 110, height: 76 },
    { url: "https://assets.gallabox.com/gb-home/industries/healthcare/umc-hospital.svg", alt: "umc-hospital", width: 110, height: 51 },
    { url: "https://assets.gallabox.com/gb-home/industries/healthcare/vcare.svg", alt: "vcare", width: 110, height: 76 },
    { url: "https://assets.gallabox.com/gb-home/industries/healthcare/vecura.svg", alt: "vecura", width: 110, height: 51 },
];

const healthCareLanding: React.FC<IIndustries> = ({ categoryResult }) => {
    return (
        <NewLayout
            description="Discover AI-powered WhatsApp automation solutions for healthcare. Elevate trust and drive appointment bookings by 100% using WhatsApp automation."
            title="AI WhatsApp Automation Solutions for Healthcare - Gallabox"
            canonical="https://gallabox.com/industry/healthcare/whatsapp"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/industries/healthcare/healthcare-og.png" }}
            schema={{
                heroOrOgImageAlt: "healthcare-industry-image",
                heroOrOgImageDescription: "Simplify patient care and drive appointment bookings by 100% with WhatsApp automation",
                heroOrOgImageUrl: "https://assets.gallabox.com/gb-home/industries/healthcare/healthcare-hero-image.png",
            }}
        >
            <Herosection herosection={herosectionData} />
            <StatsInfo statsInfo={statsInfoData} />
            <section className={`${container_classname} my-10`}>
                <h3 className="text-center text-lg font-normal py-5">TRUSTED BY 10,000+ BUSINESSES</h3>
                <ClientLogos logos={clientLogosData} />
            </section>
            <FeatureInfoCard {...featureInfo1} />
            <FeatureInfoCard {...featureInfo2} />
            <FeatureInfoCard {...featureInfo3} />
            <FeatureInfoCard {...featureInfo4} />
            <FeatureInfoCard {...featureInfo5} />
            <ProductSection
                productCardData={ecommerceProductCardData}
                title="Let each chat reflect your care"
                description="Transform your healthcare services by switching to WhatsApp automation"
            />

            <section className={`${container_classname} py-20`}>
                <h2 className="md:text-6xl text-4xl mb-12" style={{ fontFamily: "Degular Display" }}>
                    Ready-to-test healthcare chatbot templates
                </h2>
                <div className={"grid md:grid-cols-3 md:gap-5 gap-10"}>
                    {categoryResult.slice(3, 6).map((data: any) => (
                        <div
                            key={data.id}
                            className="border border-solid border-gray-200 rounded cursor-pointer"
                            onClick={() => windowOpenNewTab(`/whatsapp-chatbot-templates/${data.category}/${data.title}/${data.id}`)}
                        >
                            <div className="relative">
                                <Image src={data.picture} alt={data.title} width={280} height={170} style={{ height: "200px" }} className="w-full" />

                                <div
                                    className="absolute top-0 left-0 w-full h-full"
                                    style={{
                                        background: "linear-gradient(180deg, rgba(51, 100, 250, 0.00) 0%, rgba(51, 100, 250, 0.12) 100%)",
                                    }}
                                ></div>
                            </div>
                            <div className="p-8 bg-white">
                                {data.tags?.length > 0 && (
                                    <p className="mb-4 text-gray-700 text-sm">{data.tags.map((tag: { name: string }) => tag.name.toUpperCase()).join(" / ")}</p>
                                )}
                                <div className="h-24">
                                    <p className="mb-12 text-2xl font-medium">{data.title}</p>
                                </div>
                                <div className="flex gap-x-4 items-center">
                                    <a
                                        href={`/try-template/${data.id}`}
                                        className="border border-solid border-blue-600 text-blue-600 rounded no-underline hover:no-underline text-sm"
                                        style={{ lineHeight: "14px", padding: "8px 12px 8px 12px" }}
                                    >
                                        TRY
                                    </a>
                                    <div className="flex gap-1 items-center">
                                        <Image src="/new-industries/education/view.svg" width={20} height={20} className="w-8 h-6" alt="visited" />
                                        {data.usedCount}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <p className="mt-9 text-blue-500 flex justify-center">
                    <a href="https://gallabox.com/whatsapp-chatbot-templates/education" className="flex items-center gap-x-2">
                        View all <MdOutlineArrowForwardIos size={14} />
                    </a>
                </p>
            </section>

            <CaseStudyFeatureSection features={caseStudyFeatureCardData} />
            <IntegrationSection isLight={true} />
            <AwardsSection />
            <CTASection title="Emerge as a leading trustworthy healthcare services company while driving business growth" description="Take Gallabox for a 7-day ride" />
        </NewLayout>
    );
};

export default healthCareLanding;

export const getStaticProps: GetStaticProps = async () => {
    let categoryResult;

    try {
        await axios({
            method: "get",
            url: "https://server.gallabox.com/devapi/bot-templates",
            headers: {
                apiSecret: process.env.REACT_APP_API_SECRET,
                apiKey: process.env.REACT_APP_API_KEY,
            },
            data: {
                status: "published",
                category: "healthcare",
            },
        })
            .then(function (response) {
                categoryResult = JSON.parse(JSON.stringify(response?.data)) || [];
            })
            .catch(function (err) {
                console.log(err);
            });
    } catch (error) {
        throw new Error("Index creation failed.");
    }

    return {
        props: { categoryResult },
        ...(processEnv.isr.enable && { revalidate: 1 }),
    };
};
